import { IonToast } from '@ionic/react';
import React, { useState } from 'react';

const SWUpdateToast: React.FC<{ registration: ServiceWorkerRegistration }> = ({
  registration,
}) => {
  const showToast = useState(!!registration.waiting)[0];
  return (
    <IonToast
      isOpen={showToast}
      message='アップデートが見つかりました。自動で更新します'
      position='middle'
      duration={1000}
    />
  );
};

export default SWUpdateToast;
